import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import vuetify from './plugins/vuetify'
import store from './store/index'
import router from './router/index'
import VueFileAgent from 'vue-file-agent';
import './main.css'
import ApolloClient from 'apollo-boost'
import VueApollo from "vue-apollo";
import moment from 'moment'
const apolloClient = new ApolloClient({
  // You should use an absolute URL here
  uri: 'https://www.enfancedesarts.com/graphql'
})
Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

Vue.prototype.moment = moment

Vue.config.productionTip = false
Vue.use(VueFileAgent)

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

new Vue({
  vuetify,
  store,
  router,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
